<template>
  <div id="table-wrap">
    <el-table
      :ref="refName"
      :show-header="showHeader"
      :data="tableData"
      :header-cell-style="tableHeaderColor"
      :style="tableWidth"
      :height="tableHeight"
      @select="selectOpt"
      @select-all="selectAll"
    >
      <!-- 展开详情 -->
      <el-table-column type="expand" fixed="left" v-if="expand">
        <template slot-scope="scope">
          <el-form
            label-position="left"
            inline
            class="demo-table-expand"
            v-if="scope.row.paragraphs"
          >
            <pre
              style="text-align: center;"
              v-if="scope.row.paragraphs.length > 0"
              >{{ scope.row.paragraphs.join("\n") }}</pre
            >
            <pre
              style="text-align: center;"
              v-if="
                scope.row.paragraphs.length === 0 &&
                  scope.row.content.length > 0
              "
              >{{ scope.row.content.join("\n") }}</pre
            >
            <pre
              style="text-align: center;color:#999;"
              v-if="
                scope.row.paragraphs.length === 0 &&
                  scope.row.content.length === 0
              "
            >
暂无诗词内容</pre
            >
          </el-form>
          <el-form
            label-position="left"
            inline
            class="demo-table-expand"
            v-if="scope.row.translations"
          >
            <pre style="text-align: center;">{{
              scope.row.translations.join("\n")
            }}</pre>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column
        type="selection"
        align="center"
        v-if="selectCtrl"
        :selectable="selectable"
        width="50"
      >
      </el-table-column>

      <el-table-column
        type="index"
        align="center"
        :label="labelNo"
        fixed="left"
        v-if="orderCtrl"
        :key="Math.random()"
        width="50"
      >
        <template slot-scope="scope">
          <span v-if="!!pageSize">{{
            (currentPage - 1) * pageSize + scope.$index + 1
          }}</span>
          <span v-else>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="{ prop, label, width, btn, obj } in tableProps"
        align="center"
        show-overflow-tooltip
        :prop="prop"
        :key="prop"
        :label="label"
        :fixed="
          prop === 'handle' ||
          prop === 'giftHandle' ||
          prop === 'giftDetailsHandle'
            ? 'right'
            : false || prop === 'cardDetailsHandle'
            ? 'right'
            : false
        "
        :width="width"
      >
        <template slot-scope="scope">
          <div v-if="obj" class="omitText">
            <span v-if="prop === 'useinfo.lastTime'">{{
              scope.row | filterObj(prop) | filterDate
            }}</span>
            <span v-else-if="prop === 'useinfo.enable'">{{
              scope.row | filterObj(prop) ? "是" : "否"
            }}</span>
            <span v-else>{{ scope.row | filterObj(prop) }}</span>
          </div>

          <div
            class="omitText"
            v-else-if="
              prop === 'updated_at' ||
                prop === 'created_at' ||
                prop === 'updatedAt' ||
                prop === 'publishAt' ||
                prop === 'endAt' ||
                prop === 'pay_time' ||
                prop === 'liveAt'
            "
          >
            <span>{{ scope.row[prop] | filterDate }}</span>
          </div>
          <div class="omitText" v-else-if="prop === 'langs'">
            <span v-if="scope.row['langs'] && scope.row['langs'].length">{{
              scope.row["langs"].join("、")
            }}</span>
            <span v-else>-</span>
          </div>

          <div v-else-if="prop === 'handle'">
            <span v-for="item in btn" :key="item">
              <!-- <span v-if="item === 'swithBtn'">12312 </span> -->
              <el-switch
                v-if="item === 'swithBtn'"
                v-model="scope.row['status']"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="switchChange(scope)"
              >
              </el-switch>
              <span
                v-else
                :class="btnStyle(item)"
                @click="tableHandle(item, scope)"
                >{{ item }}</span
              >
            </span>
          </div>

          <span v-else class="omitText">{{
            scope.row[prop] && scope.row[prop] !== null ? scope.row[prop] : "-"
          }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResizeMixin from "@/mixins/resize";

export default {
  components: {},
  computed: {
    ...mapGetters(["hasData", "userInfo"]),
    labelNo() {
      return this.$t("commonMsg.No");
    }
  },
  mixins: [ResizeMixin],
  props: {
    refName: {
      type: String,
      default: "appTable"
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    tableWidth: {
      type: String,
      default: "width:100%"
    },
    tableData: {
      type: Array,
      default: () => []
    },
    tableProps: {
      type: Array
    },
    selectCtrl: {
      type: Boolean,
      default: false
    },
    orderCtrl: {
      type: Boolean,
      default: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    expand: {
      type: Boolean,
      default: false
    },
    pageSize: Number
  },

  data() {
    return {
      selectDataIds: [],
      selectData: [],
      scopeItem: null
    };
  },

  filters: {
    filterObj(obj, value) {
      let arr = value.split(".");
      let val = {};
      for (let item of arr) {
        if (!Object.keys(val).length) {
          if (!obj[item]) {
            val = "-";
            break;
          } else {
            val = obj[item];
          }
        } else {
          if (!val[item]) {
            val = "-";
            break;
          } else {
            val = val[item];
          }
        }
      }
      return val;
    }
  },

  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;";
      }
    },

    btnStyle(item) {
      let className;
      switch (item) {
        case this.$t("commonMsg.checkDetails"):
        case this.$t("commonMsg.edit"):
          className = "checkDetailsBtn";
          break;
        case this.$t("commonMsg.del"):
        case this.$t("commonMsg.destroy"):
        case this.$t("commonMsg.correction"):
        case this.$t("sale.gift.handle"):
        case "Token失效":
        case "笔记PDF修正":
        case "OSS查询":
        case "CB查询":
          className = "delBtn";

          break;

        default:
          break;
      }
      return className;
    },

    // 表格上下移动排序
    tableSort(type, scope) {
      this.emitEvn(type, scope, "tableSort");
    },

    switchChange(scope) {
      this.emitEvn(null, scope, "switchChange");
    },

    // 表格操作按钮
    tableHandle(type, scope) {
      this.emitEvn(type, scope, "tableHandle");
    },

    emitEvn(type, scope, evn) {
      let obj = {
        type: type || "",
        data: scope
      };
      this.$emit(evn, obj);
    },

    selectOpt(selection, row) {
      if (this.selectDataIds.includes(row.id)) {
        let idx = this.selectDataIds.indexOf(row.id);
        this.selectDataIds.splice(idx, 1);
        this.selectData.splice(idx, 1);
      } else {
        this.selectDataIds = [...this.selectDataIds, row.id];
        this.selectData = [...this.selectData, row];
      }

      this.sendSelectData();
    },

    selectAll(selection) {
      if (!selection.length) {
        this.selectDataIds = [];
        this.selectData = [];
        return;
      }
      for (let item of selection) {
        if (!this.selectDataIds.includes(item.id)) {
          this.selectDataIds.push(item.id);
          this.selectData.push(item);
        }
      }

      this.sendSelectData();
    },

    sendSelectData() {
      this.$emit("tableSelection", {
        data: this.selectData,
        ids: this.selectDataIds
      });
    },

    selectable(row, index) {
      return this.hasData.includes(row.id) ? false : true;
    },

    toggleSelection() {
      if (!this.selectDataIds.length) return;
      for (let row of this.tableData) {
        if (this.selectDataIds.includes(row.id))
          this.$refs[this.refName].toggleRowSelection(row, true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#table-wrap {
  height: 100%;
  .appTable-move {
    > i {
      display: inline-block;
      width: 22px;
      height: 22px;
      cursor: pointer;
      font-size: 20px;
      margin: 0 5px;
      font-weight: bold;
      vertical-align: middle;
    }
    .move-up {
      background: url("~@/assets/img/cmb_move_up.png") no-repeat;
    }
    .move-down {
      background: url("~@/assets/img/cmb_move-down.png") no-repeat;
    }
  }
  .green {
    color: green;
  }
}
</style>
